import { connect } from 'react-redux';
import Banner from '../components/Banner';
import * as selectors from '../selectors';
function mapStateToProps(state) {
    return {
        isUserAuthenticated: selectors.isUserAuthenticated(state),
        isUserPartOfThisCompany: selectors.isUserPartOfThisCompany(state),
    };
}
export default connect(mapStateToProps)(Banner);
